module.exports = __webpack_public_path__ + "img/menu_btn.136bec0f.png";